// action type constants
export const SETUP_MAP_SERVICES = 'SETUP_MAP_SERVICES';
export const SET_MAP_DIV = 'SET_MAP_DIV';
export const SET_MAP_LOADED = 'SET_MAP_LOADED';
export const SET_LOCATION = 'SET_LOCATION';

// actionCreators
export const setupMapServices = () => ({ type: SETUP_MAP_SERVICES });
export const setMapDiv = (payload) => ({ type: SET_MAP_DIV, payload });
export const setMapLoaded = (payload) => ({ type: SET_MAP_LOADED, payload });
export const setLocation = (payload) => ({ type: SET_LOCATION, payload });

export const getMapDiv = (state) => state.mapRefs.mapDiv;
export const getMapLoaded = (state) => state.mapRefs.loaded;
export const getLocation = (state) => state.mapRefs.location;

const initialState = {
  mapDiv: '',
  loaded: false,
  location: {},
};

// reducer
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MAP_DIV:
      state.mapDiv = payload;
      return;
    case SET_MAP_LOADED:
      state.loaded = payload;
      return;
    case SET_LOCATION:
      state.location = payload;
      return;
    default:
      return state;
  }
};
